import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import WeekText from "../../Main/Prevention/Week/WeekText.js";
import data from "../../Data/svo/svoData.json";

export default function ParticipantsSVO() {
  return (
    <section className="structure">
      <Breadcrumbs />

      <h1 className="weekpage__title">Участникам СВО</h1>
      <div>
        <WeekText data={data} />
      </div>
    </section>
  );
}
